module.exports = __webpack_public_path__ + "img/icon-search.bf72a1f7.svg";